import {SponsorshipInfoResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/advertisement/service.types';
import {useTranslation} from '@aboutyou/i18n';
import {
  ContentPopper,
  ContentPopperProps,
  RichText,
  SecondaryContentPopperButton,
  tabletAndUpLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {useSponsoredProductPopup} from './utils/useSponsoredProductPopup';

export const SponsoredProductPopupView: React.FC<
  SponsorshipInfoResponse & {
    LayoutComponent: ContentPopperProps['LayoutComponent'];
  }
> = ({headline, body, LayoutComponent}) => {
  const {t} = useTranslation();
  const {isOpen, cancel} = useSponsoredProductPopup();

  return (
    <ContentPopper
      data-testid="sponsProductPopup"
      LayoutComponent={LayoutComponent}
      onClose={cancel}
      fixedSmallWidth={false}
      open={isOpen}
      headerContent={headline}
      bodyContent={
        <BodyContent>
          <RichText as="p">{body.text}</RichText>
        </BodyContent>
      }
      footerContent={
        <SecondaryContentPopperButton label={t('Close')} onClick={cancel} />
      }
    />
  );
};

const BodyContent = styled.div`
  overflow-y: auto;

  > p {
    line-height: 1.4;
    margin: 0;

    b {
      display: block;
      line-height: 1;
      margin-bottom: -1.8rem;
    }

    ul {
      display: flex;
      flex-direction: column;
      gap: 0.2rem;
      margin-top: -0.5rem;
      padding-left: 1.5rem;
      list-style: disc;
    }

    ul ~ b {
      display: block;
      margin-top: -1.5rem;

      ${tabletAndUpLinaria(`margin-top: -1rem;`)};
    }
  }
`;
